(function () {

    const style = document.createElement('style');
    style.textContent = `
    .m-cart__column--quantity,
    m-quantity-input,
    .m-quantity {
        display: none !important;
    }
    `;
    document.head.appendChild(style);


  async function getCart() {
    const originalFetch = window._originalFetch || fetch;
    const res = await originalFetch('/cart.js');
    return res.json();
  }

  function showError(message) {
    const existing = document.getElementById('cart-restriction-error');
    if (existing) existing.remove();

    const error = document.createElement('div');
    error.id = 'cart-restriction-error';
    error.style.cssText = `
      background: #fff3f3;
      border: 1px solid #e8a0a0;
      color: #c0392b;
      padding: 12px 16px;
      margin-bottom: 12px;
      border-radius: 4px;
      font-size: 14px;
      line-height: 1.5;
    `;
    error.textContent = message;

    const isCartPage = window.location.pathname === '/cart';
    const cartDrawer = document.querySelector('m-cart-drawer');
    const cartDrawerOpen = cartDrawer && !cartDrawer.classList.contains('m:hidden')
      && getComputedStyle(cartDrawer).display !== 'none';

    if (isCartPage) {
      const cartItems = document.querySelector('[data-minimog-cart-items]')
        || document.querySelector('.m-cart-items')
        || document.querySelector('m-cart');
      if (cartItems) {
        error.style.margin = '0 0 16px 0';
        cartItems.insertBefore(error, cartItems.firstChild);
      }
    } else if (cartDrawerOpen) {
      const drawerInner = document.querySelector('.m-cart-drawer__inner')
        || document.querySelector('m-cart-drawer-items');
      if (drawerInner) {
        error.style.margin = '12px 16px';
        drawerInner.insertBefore(error, drawerInner.firstChild);
      }
    } else {
      const atcButton = document.querySelector('button.m-add-to-cart')
        || document.querySelector('[name="add"]');
      if (atcButton) {
        const form = atcButton.closest('form');
        if (form) {
          form.insertBefore(error, atcButton.parentNode);
        } else {
          atcButton.parentNode.insertBefore(error, atcButton);
        }
      }
    }

    setTimeout(() => error.remove(), 5000);
  }

  async function checkCartRestrictions(variantId, cart) {
    const res = await (window._originalFetch || fetch)(`/variants/${variantId}.js`);
    const variant = await res.json();

    const newProductId = variant.product_id;
    const newProductType = variant.product_type;

    if (cart.items.some(item => item.product_id === newProductId)) {
      showError('Je kunt van elk product slechts één exemplaar aan je winkelwagen toevoegen.');
      return false;
    }

    if (cart.items.length > 0 && cart.items.some(item => item.product_type !== newProductType)) {
      showError('Je winkelwagen kan slechts één producttype tegelijk bevatten.');
      return false;
    }

    return true;
  }

  // 1. Intercept form submissions (order page)
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    const cart = await getCart();
    const allowed = await checkCartRestrictions(variantId, cart);
    if (allowed) form.submit();

  }, true);

  // 2. Intercept fetch calls (Globo and other AJAX add-to-cart)
  window._originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const [resource, config] = args;
    const url = typeof resource === 'string' ? resource : resource?.url || '';

    if (url.includes('/cart/add')) {
      try {
        let variantId = null;

        if (config?.body) {
          const body = config.body;
          if (typeof body === 'string') {
            try {
              const parsed = JSON.parse(body);
              variantId = parsed.id || parsed.items?.[0]?.id;
            } catch {
              variantId = new URLSearchParams(body).get('id');
            }
          } else if (body instanceof FormData) {
            variantId = body.get('id');
          }
        }

        if (variantId) {
          const cart = await getCart();
          const allowed = await checkCartRestrictions(variantId, cart);
          if (!allowed) {
            return new Response(JSON.stringify({ status: 422, message: 'Je winkelwagen kan slechts één producttype tegelijk bevatten.' }), {
              status: 422,
              headers: { 'Content-Type': 'application/json' }
            });
          }
        }
      } catch (err) {
        console.error('Cart restriction check failed:', err);
      }
    }

    return window._originalFetch.apply(this, args);
  };

  // 3. Block quantity increases above 1 in cart
  document.addEventListener('change', async function (e) {
    const input = e.target;
    if (!input.dataset.index) return;
    const qty = parseInt(input.value);
    if (qty > 1) {
      input.value = 1;
      showError('De maximale hoeveelheid per product is 1.');
    }
  });

})();
